// @flow
export { default } from './UserProductCardList';



// WEBPACK FOOTER //
// ./src/components/user/UserProductCardList/index.js